import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcArrowupFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.55 15c-.46 0-.716-.539-.429-.903l5.45-6.888a.546.546 0 0 1 .858 0l5.45 6.888c.287.364.031.903-.43.903z"
  }));
}
var IcArrowupFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowupFill));

export { IcArrowupFill as I };
